import { render, staticRenderFns } from "./report-image-card.vue?vue&type=template&id=7398ff24&scoped=true"
import script from "./report-image-card.vue?vue&type=script&lang=js"
export * from "./report-image-card.vue?vue&type=script&lang=js"
import style0 from "./report-image-card.vue?vue&type=style&index=0&id=7398ff24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7398ff24",
  null
  
)

export default component.exports